module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/video-dec-2-m-63296a51fd03616c030ad24a93b61358.png";